import {ReactNode} from "react";
import {X} from "lucide-react";
import {motion, AnimatePresence} from "framer-motion";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  titleModal: string;
  children: ReactNode;
};

const Modal = ({isOpen, onClose, titleModal, children}: ModalProps) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="modal-container-iris-blk"
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          exit={{opacity: 0}}
          transition={{duration: 0.25}}>
          <motion.div
            className="modal-container-iris-main-blk"
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            transition={{duration: 0.25}}>
            {/* Header */}
            <div className="header-modal">
              <h1 className="header-modal-title">iCXeed | {titleModal}</h1>
              <button className="header-modal-close" onClick={onClose}>
                <X />
              </button>
            </div>

            {/* Scrollable Content */}
            <div className="modal-content-iris-blk">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Modal;
